import { z } from 'zod';

export const CabinetSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1),
  created_at: z.string().datetime(),
});

export type Cabinet = z.infer<typeof CabinetSchema>;
